import AdminService from '../services/admin.services'

const state = {
    emails: []
}

const getters = {
    getEmails: (state) => state.emails
}

const actions = {
    fetchScheduleEmails({commit}, data){
        return AdminService.post_entity(data.payload, data.entity).then(
            response => {
                commit('SET_LIST', response.data)
                return Promise.resolve(response.status)
            }
        )
    },
    delete({commit}, data){
        return AdminService.delete_entity(data.payload, data.entity).then(
            response => {
                return Promise.resolve(response.status)
            }
        )
    }

}

const mutations = {
    SET_LIST(state, rs){
        state.emails = rs.data
    }
}

export const schedule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}